/* eslint-disable camelcase */
import { AuthHeader } from "../components/proposals/contexts/configContext";

export const getFormattedUserName = user => {
  if (!user) return "Unknown";
  if (user.firstName && user.lastName)
    return `${user.firstName} ${user.lastName}`;
  if (user.firstName || user.lastName)
    return user.firstName ? `${user.firstName}` : `${user.lastName}`;
  return user.emailAddress || "Unknown";
};

const cookieParser = (cookieString: string): { [key: string]: string } => {
  if (!cookieString) {
    return {};
  }
  const pairs = cookieString.split(";").map(cookie => cookie.split("="));
  const cookieObj = pairs.reduce((obj, cookie) => {
    // eslint-disable-next-line no-param-reassign
    obj[decodeURIComponent(cookie[0].trim())] = decodeURIComponent(
      cookie[1].trim()
    );
    return obj;
  }, {});
  return cookieObj;
};

export const getAuthHeadersFromCookie = (): AuthHeader => {
  const { access_token_cookie } = cookieParser(document.cookie);
  if (!access_token_cookie) {
    return {};
  }
  return {
    Authorization: `Bearer ${access_token_cookie}`,
  };
};

/**
 * pushedArray returns a shallow copy of an input array trimmed to
 * a maximum length.
 */
export const pushedArray = <T>(
  inputArray: T[],
  value: T,
  maxLength: number
): T[] => {
  const result = [...(inputArray ?? [])];
  result.push(value);
  return result.slice(-maxLength);
};
